import React from "react";
import { useEffect, useState } from "react";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from '../../axios/axiosconf';
import { getFechaActual } from "../../../resources/Helper";

function ListaCitasDia() {

    const [toastMsg, setToastMsg] = useState();
    const [items, setItems] = useState([]);
    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: getFechaActual()
            }
        }

        console.log(conf);

        axios.get('lista-citas-dia', conf)
            .then(response => {
                if (response.status===200) {
                    setItems(response.data);
                }
            })
            .catch(error => console.log(error.response.data))

    },[]);


    const nombrePaciente = (item) => {

        let nombres = item.segundo_nombre ? item.primer_nombre + ' ' + item.segundo_nombre : item.primer_nombre;
        
        return nombres + ' ' + item.primer_apellido; 
    }

    const cols = [
        { name:'Hora', selector:row => row.hora_cita },
        { name:'Paciente', selector:row => nombrePaciente(row) },
        { name:'Duración', selector:row => row.duracion_cita },
        { name:'Motivo consulta', selector:row => row.motivo_consulta },
        { name:'Estado', selector:row => row.estado },
        { name:'Acción', cell:row => getBotones(row) }
    ];

    const getBotones = (item) => {
        
        if (item.estado_paciente=='1') {
            return <Link to={'/atender-paciente?id='+item.id_paciente} className="btn btn-primary btn-sm"><i className="fas fa-user-md"></i>&nbsp;Atender</Link>
        }
        else {
            return <Link to={'/editar-paciente?id='+item.id_paciente} className="btn btn-primary btn-sm"><i className="far fa-edit"></i>&nbsp;Completar anamnesis</Link>
        }
    }

    return <div className="hold-transition">
                <Header />
                <Aside activelink="home" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Citas del día</h1>
                                </div>
                                <div className="col-sm-6 botones-home">
                                    <Link to="/home" className="btn btn-primary">Mi Agenda <i className="fas fa-calendar-alt"></i></Link>
                                    &nbsp;
                                    <Link to="/busqueda-citas" className="btn btn-primary">Buscar citas <i className="fas fa-search"></i></Link>
                                    &nbsp;
                                    <Link to="/control-asistencia" className="btn btn-primary">Control asistencia última cita <i className="far fa-calendar-alt"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">

                            <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                id={'citas-dia'}
                                />
                            
                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>
}
export default ListaCitasDia;